var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 188,
    viewBox: "0 0 184 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(-556 711)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 184,
    height: 188,
    transform: "translate(556 -711)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video-slash",
    "data-name": "Icon awesome-video-slash",
    d: "M182,131.543l-15.794-12.2a9.046,9.046,0,0,0,8.385-8.931v-73.8A9.2,9.2,0,0,0,160.116,29.2l-31.473,21.71v39.4l-9.189-7.093V32.1a13.726,13.726,0,0,0-13.726-13.726H35.573L13.06.97a4.612,4.612,0,0,0-6.461.8L.97,9.011a4.575,4.575,0,0,0,.8,6.432l10.481,8.1,107.2,82.875,51.259,39.629a4.612,4.612,0,0,0,6.461-.8l5.628-7.265a4.552,4.552,0,0,0-.8-6.432ZM9.183,114.916a13.726,13.726,0,0,0,13.726,13.726h82.818a13.625,13.625,0,0,0,8.5-3.015L9.183,44.418Z",
    transform: "translate(555.998 -691.002)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOff);
export default __webpack_public_path__ + "static/media/cam-off.497b79794c4298a2e59620860b15f064.svg";
export { ForwardRef as ReactComponent };